import React from 'react';
import {Paper, Typography} from "@mui/material";


import ProcurementContainer from '../../procurement/containers/ProcurementContainer';
import CreateExternalItemMapping from '../component/CreateExternalItemMapping';
import ExternalItemMappingListComponent from '../lists/externalItemMappingList';



const ExternalItemMappingPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        External Item Mapping
      </Typography>
     
        <CreateExternalItemMapping/>
    
      <Paper sx={{my: 5}}>
      <ExternalItemMappingListComponent/>
      </Paper>
    </ProcurementContainer>

  )
}

export default ExternalItemMappingPage